<template>
    <console-content max-width="1280">

        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">
                <span v-if="$route.params._cp">CP 상세</span>
                <span v-else>CP 생성</span>
            </v-col>
            <v-spacer/>
        </v-row>

        <v-row class="mt-3">
            <v-col cols="12" md="12" class="py-0 pr-md-1">
                <v-card class="mx-1" :disabled="!$hasScope(['root', 'admin'])">
                    <v-card-title class="subtitle-2">기본정보</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col class="py-0">
                                <v-text-field v-model="cp.username" label="아이디" placeholder=" " hide-details></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                                <v-password-field v-model="cp.password" label="비밀번호" placeholder=" " hide-details></v-password-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col class="py-0">
                                <v-text-field v-model="cp.cpKey" label="API PASSWORD" placeholder=" " hide-details></v-text-field>
                            </v-col>
                            <v-col class="py-0"></v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col class="py-0">
                                <v-text-field v-model="cp.name" label="업체명" placeholder=" " hide-details></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field v-model="cp.phone" label="연락처" placeholder=" " hide-details></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col class="py-0">
                                <v-text-field v-model="cp.email" label="이메일" placeholder=" " hide-details></v-text-field>
                            </v-col>
                            <!-- <v-col class="py-0">
                                <v-text-field v-model="cp.key" label="key" placeholder=" " hide-details append-icon="mdi-key" @click:append="setKey"></v-text-field>
                            </v-col> -->
                        </v-row>
                        <v-row class="mt-4">
                            <v-col class="py-0">
                                <v-text-field v-model="cp.postcode" label="우편번호" placeholder=" " hide-details></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col class="py-0">
                                <v-text-field v-model="cp.address1" label="기본주소" placeholder=" " hide-details></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field v-model="cp.address2" label="상세주소" placeholder=" " hide-details></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col class="py-0">
                                <v-text-field v-model="cp.noti" label="noti url" placeholder=" " hide-details></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field v-model="cp.ci" label="ci" placeholder=" " hide-details></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions/>
                </v-card>

                <v-card class="mx-1 mt-4" :disabled="!$hasScope(['root', 'admin'])">
                    <v-card-text>
                        <div class="subtitle-1 pt-4 d-flex">
                            <strong>CP 등급</strong>
                        </div>
                        <v-row class="mt-4">
                            <v-col cols="12" md="4" class="py-0">
                                <v-select v-model="cp.riskManagement.giftcard.level" :items="giftcardLevels" item-text="text" item-value="value" label="등급" placeholder=" ">
                                </v-select>
                            </v-col>
                        </v-row>
                        <div class="subtitle-1 pt-4 d-flex">
                            <strong>발행 금액 제한</strong>
                            <v-spacer />
                            <v-switch v-model="cp.riskManagement.giftcard.limitEnabled" dense hide-details class="mt-0" />
                        </div>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field v-model="cp.riskManagement.giftcard.dailyLimit" label="발행 금액 제한(일간)" type="number" placeholder=" " :disabled="!cp.riskManagement.giftcard.limitEnabled" clearable outlined background-color="white" dense hide-details></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field v-model="cp.riskManagement.giftcard.monthlyLimit" label="발행 금액 제한(월간)" type="number" placeholder=" " :disabled="!cp.riskManagement.giftcard.limitEnabled" clearable outlined background-color="white" dense hide-details></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider />
                    <v-card-text class="content">
                        <div class="subtitle-1 pt-4"><strong>관리자 알람</strong></div>
                        <v-row class="mt-4">
                            <v-col cols="12" md="3" class="py-0">
                                <v-text-field v-model="cp.riskManagement.giftcard.alarmPrices[0]" label="잔여 알람금액(1차)" placeholder=" " clearable outlined color="secondary" background-color="white" dense hide-details @input="createComma(cp.riskManagement.giftcard.alarmPrices[0], 0)"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3" class="py-0">
                                <v-text-field v-model="cp.riskManagement.giftcard.alarmPrices[1]" label="잔여 알람금액(2차)" placeholder=" " clearable outlined color="secondary" background-color="white" dense hide-details @input="createComma(cp.riskManagement.giftcard.alarmPrices[1], 1)"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3" class="py-0">
                                <v-text-field v-model="cp.riskManagement.giftcard.alarmPrices[2]" label="잔여 알람금액(3차)" placeholder=" " clearable outlined color="secondary" background-color="white" dense hide-details @input="createComma(cp.riskManagement.giftcard.alarmPrices[2], 2)"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3" class="py-0">
                                <v-text-field v-model="cp.riskManagement.giftcard.alarmPrices[3]" label="잔여 알람금액(4차)" placeholder=" " clearable outlined color="secondary" background-color="white" dense hide-details @input="createComma(cp.riskManagement.giftcard.alarmPrices[3], 3)"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row no-gutters align="center" class="mt-6">
                            <v-col class="pr-1">
                                <v-text-field v-model="name" label="담당자 이름" placeholder=" " hide-details outlined color="secondary" background-color="white" dense></v-text-field>
                            </v-col>
                            <v-col class="pl-1">
                                <v-text-field v-model="phone" label="알람 연락처" placeholder=" " hide-details outlined color="secondary" background-color="white" dense @keydown.enter="() => { cp.riskManagement.alarmPhones.push(phone); phone = ''; }"></v-text-field>
                            </v-col>
                            <v-col cols="auto" class="pl-1">
                                <v-btn color="secondary" @click="() => { cp.riskManagement.giftcard.alarmPhones.push(phone), cp.riskManagement.giftcard.alarmNames[cp.riskManagement.giftcard.alarmPhones.length - 1] = name, phone = '', name = ''; }"><v-icon left size="20">mdi-plus</v-icon>추가</v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col v-for="alarmPhone, index in cp.riskManagement.giftcard.alarmPhones" :key="index" cols="auto" class="pr-1">
                                <v-chip close color="secondary" @click:close="cp.riskManagement.giftcard.alarmPhones.splice(index, 1), cp.riskManagement.giftcard.alarmNames.splice(index, 1)">{{ cp.riskManagement.giftcard.alarmNames[index] }} {{ alarmPhone }}</v-chip>
                            </v-col>
                        </v-row>
                        <v-textarea v-model="cp.riskManagement.giftcard.alarmMessage" label="알람 메시지" placeholder=" " outlined color="secondary" background-color="white" hide-details class="mt-4"></v-textarea>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="my-6">
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn :disabled="!$hasScope(['root', 'admin'])" color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer/>
        </v-row>

    </console-content>
</template>

<script>
import api from "@/api";
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
import { mdiMicrosoftExcel } from "@mdi/js";
import { v4 } from "uuid"

export default {
    components: {
        ConsoleContent,
        VPasswordField
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            cp: {
                username: null,
                password: null,
                name: null,
                phone: null,
                email: null,
                postcode: null,
                address1: null,
                address2: null,

                noti: null,
                ci: null,

                companyName: null,
                organization: null,
                code: null,
                key: null,

                riskManagement: {
                    giftcard: {
                        level: "normal",
                        limitEnabled: false,
                        dailyLimit: null,
                        monthlyLimit: null,

                        alarmPrices: [0, 0, 0, 0],
                        alarmPhones: [],
                        alarmMessage: null
                    }
                }
            },

            giftcardLevels: [
                { text: "normal", value: "normal" },
                { text: "vip", value: "vip" },
                { text: "vvip", value: "vvip" },
            ],

            name: "",
            phone: ""
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            if(this.$route.params._cp){
                let { cp } = await api.console.cps.get({ _id: this.$route.params._cp });
                for(let i = 0; i < cp.riskManagement.giftcard.alarmPrices.length; i++) {
                    cp.riskManagement.giftcard.alarmPrices[i] = cp.riskManagement.giftcard.alarmPrices[i].format()
                }
                this.cp = {
                    ...this.cp,
                    ...cp
                };
            }
        },

        async save(){
            await this.removeComma();
            this.cp._id ? await api.console.cps.put(this.cp) : await api.console.cps.post(this.cp);
            alert("저장되었습니다");
            this.$router.push(`/console/cps`);
        },
        setKey() {
            const uuid = v4();
            this.cp.key = uuid;
        },
        createComma(alarmPrices, index) {
            this.cp.riskManagement.giftcard.alarmPrices[index] = String(alarmPrices).replace(/[^0-9]/g,'').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        async removeComma() {
            for(let i = 0; i < this.cp.riskManagement.giftcard.alarmPrices.length; i++) {
                if (typeof this.cp.riskManagement.giftcard.alarmPrices[i] === "string") {
                    this.cp.riskManagement.giftcard.alarmPrices[i] = this.cp.riskManagement.giftcard.alarmPrices[i].replaceAll(",","")
                }
            } 
        }
    }
}
</script>   